// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Overlay ── */
.cfc-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

/* ── Modal ── */
.cfc-modal {
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-width: 720px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

/* ── Body ── */
.cfc-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* ── Left Panel ── */
.cfc-left-panel {
  width: 200px;
  flex-shrink: 0;
  background: #f5f5f5;
  border-right: 1px solid #e0e0e0;
  padding-top: 16px;
  overflow-y: auto;
}

.cfc-panel-heading {
  display: block;
  padding: 0 16px;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cfc-category-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: background 0.15s, border-color 0.15s;
}

.cfc-category-item:hover {
  background: #ffffff;
}

.cfc-category-item--active {
  background: #ffffff;
  border-left-color: #1976d2;
}

.cfc-category-label {
  font-size: 13px;
  color: #333;
  font-weight: 400;
}

.cfc-category-item--active .cfc-category-label {
  color: #1976d2;
  font-weight: 600;
}

.cfc-category-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1976d2;
  flex-shrink: 0;
}

/* ── Right Panel ── */
.cfc-right-panel {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.cfc-right-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
}

/* ── Search ── */
.cfc-search-wrap {
  position: relative;
  margin-bottom: 16px;
}

.cfc-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
}

.cfc-search-input {
  width: 100%;
  height: 36px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0 12px 0 34px;
  font-size: 13px;
  color: #0b0b0b;
  background: #fff;
  outline: none;
  box-sizing: border-box;
  font-family: inherit;
}

.cfc-search-input:focus {
  border-color: #1976d2;
}

/* ── Options ── */
.cfc-options-list {
  display: flex;
  flex-direction: column;
}

.cfc-option-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}

.cfc-option-row:last-child {
  border-bottom: none;
}

.cfc-checkbox {
  width: 16px;
  height: 16px;
  accent-color: #1976d2;
  cursor: pointer;
  flex-shrink: 0;
}

.cfc-option-label {
  font-size: 13px;
  color: #333;
}

.cfc-empty {
  font-size: 13px;
  color: #999;
  margin-top: 8px;
}

/* ── Footer ── */
.cfc-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  border-top: 1px solid #e0e0e0;
}

.cfc-btn-clear,
.cfc-btn-apply {
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 20px;
  font-family: inherit;
  transition: background 0.15s, color 0.15s;
}

.cfc-btn-clear {
  background: transparent;
  color: #999;
}

.cfc-btn-clear:hover {
  color: #555;
  background: #f0f0f0;
}

.cfc-btn-apply {
  background: #1976d2;
  color: #ffffff;
}

.cfc-btn-apply:hover {
  background: #1565c0;
}

.cfc-btn-icon {
  width: 15px;
  height: 15px;
}

/* ── Panel variant (no dark overlay, anchored top-right) ── */
.cfc-overlay--panel {
  background: transparent;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 180px 24px 0 0;
}

.cfc-modal--panel {
  max-width: 660px;
  min-height: unset;
  border: 1px solid #e0e0e0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);
}

/* ── Dark theme ── */
.dark .cfc-modal {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .cfc-left-panel {
  background: #0f172a;
  border-right-color: #334155;
}

.dark .cfc-panel-heading {
  color: #64748b;
}

.dark .cfc-category-item:hover {
  background: #1e293b;
}

.dark .cfc-category-item--active {
  background: #1e293b;
  border-left-color: #3b82f6;
}

.dark .cfc-category-label {
  color: #94a3b8;
}

.dark .cfc-category-item--active .cfc-category-label {
  color: #60a5fa;
}

.dark .cfc-right-title {
  color: #f1f5f9;
}

.dark .cfc-search-input {
  background: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .cfc-search-input:focus {
  border-color: #3b82f6;
}

.dark .cfc-search-icon {
  color: #64748b;
}

.dark .cfc-option-row {
  border-bottom-color: #334155;
}

.dark .cfc-option-label {
  color: #f1f5f9;
}

.dark .cfc-empty {
  color: #64748b;
}

.dark .cfc-footer {
  border-top-color: #334155;
}

.dark .cfc-btn-clear {
  color: #64748b;
}

.dark .cfc-btn-clear:hover {
  color: #94a3b8;
  background: #334155;
}

.dark .cfc-modal--panel {
  border-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/CustomFilterComponent/CustomFilterComponent.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* ── Overlay ── */\n.cfc-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n/* ── Modal ── */\n.cfc-modal {\n  background: #ffffff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 720px;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n}\n\n/* ── Body ── */\n.cfc-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* ── Left Panel ── */\n.cfc-left-panel {\n  width: 200px;\n  flex-shrink: 0;\n  background: #f5f5f5;\n  border-right: 1px solid #e0e0e0;\n  padding-top: 16px;\n  overflow-y: auto;\n}\n\n.cfc-panel-heading {\n  display: block;\n  padding: 0 16px;\n  margin-bottom: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.cfc-category-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  cursor: pointer;\n  border-left: 3px solid transparent;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.cfc-category-item:hover {\n  background: #ffffff;\n}\n\n.cfc-category-item--active {\n  background: #ffffff;\n  border-left-color: #1976d2;\n}\n\n.cfc-category-label {\n  font-size: 13px;\n  color: #333;\n  font-weight: 400;\n}\n\n.cfc-category-item--active .cfc-category-label {\n  color: #1976d2;\n  font-weight: 600;\n}\n\n.cfc-category-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #1976d2;\n  flex-shrink: 0;\n}\n\n/* ── Right Panel ── */\n.cfc-right-panel {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.cfc-right-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 16px 0;\n}\n\n/* ── Search ── */\n.cfc-search-wrap {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.cfc-search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #999;\n  pointer-events: none;\n}\n\n.cfc-search-input {\n  width: 100%;\n  height: 36px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 0 12px 0 34px;\n  font-size: 13px;\n  color: #0b0b0b;\n  background: #fff;\n  outline: none;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.cfc-search-input:focus {\n  border-color: #1976d2;\n}\n\n/* ── Options ── */\n.cfc-options-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.cfc-option-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n}\n\n.cfc-option-row:last-child {\n  border-bottom: none;\n}\n\n.cfc-checkbox {\n  width: 16px;\n  height: 16px;\n  accent-color: #1976d2;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.cfc-option-label {\n  font-size: 13px;\n  color: #333;\n}\n\n.cfc-empty {\n  font-size: 13px;\n  color: #999;\n  margin-top: 8px;\n}\n\n/* ── Footer ── */\n.cfc-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cfc-btn-clear,\n.cfc-btn-apply {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 20px;\n  font-family: inherit;\n  transition: background 0.15s, color 0.15s;\n}\n\n.cfc-btn-clear {\n  background: transparent;\n  color: #999;\n}\n\n.cfc-btn-clear:hover {\n  color: #555;\n  background: #f0f0f0;\n}\n\n.cfc-btn-apply {\n  background: #1976d2;\n  color: #ffffff;\n}\n\n.cfc-btn-apply:hover {\n  background: #1565c0;\n}\n\n.cfc-btn-icon {\n  width: 15px;\n  height: 15px;\n}\n\n/* ── Panel variant (no dark overlay, anchored top-right) ── */\n.cfc-overlay--panel {\n  background: transparent;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding: 180px 24px 0 0;\n}\n\n.cfc-modal--panel {\n  max-width: 660px;\n  min-height: unset;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);\n}\n\n/* ── Dark theme ── */\n.dark .cfc-modal {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .cfc-left-panel {\n  background: #0f172a;\n  border-right-color: #334155;\n}\n\n.dark .cfc-panel-heading {\n  color: #64748b;\n}\n\n.dark .cfc-category-item:hover {\n  background: #1e293b;\n}\n\n.dark .cfc-category-item--active {\n  background: #1e293b;\n  border-left-color: #3b82f6;\n}\n\n.dark .cfc-category-label {\n  color: #94a3b8;\n}\n\n.dark .cfc-category-item--active .cfc-category-label {\n  color: #60a5fa;\n}\n\n.dark .cfc-right-title {\n  color: #f1f5f9;\n}\n\n.dark .cfc-search-input {\n  background: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .cfc-search-input:focus {\n  border-color: #3b82f6;\n}\n\n.dark .cfc-search-icon {\n  color: #64748b;\n}\n\n.dark .cfc-option-row {\n  border-bottom-color: #334155;\n}\n\n.dark .cfc-option-label {\n  color: #f1f5f9;\n}\n\n.dark .cfc-empty {\n  color: #64748b;\n}\n\n.dark .cfc-footer {\n  border-top-color: #334155;\n}\n\n.dark .cfc-btn-clear {\n  color: #64748b;\n}\n\n.dark .cfc-btn-clear:hover {\n  color: #94a3b8;\n  background: #334155;\n}\n\n.dark .cfc-modal--panel {\n  border-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
